import * as Sentry from '@sentry/vue'
import type { App as VueApp } from 'vue'
import type { Router } from 'vue-router'
import { getTelegramPlatform, getTelegramVersion, isInsideTelegram } from '@/telegramWebApp'

function parseSampleRate(value: string | undefined): number | undefined {
  if (!value) return undefined
  const rate = Number(value)
  if (Number.isNaN(rate)) return undefined
  return Math.min(Math.max(rate, 0), 1)
}

// No same-origin tunnel/proxy: reports straight to VITE_SENTRY_DSN. Unset disables it entirely.
export function initSentry(app: VueApp, router: Router): void {
  const dsn = import.meta.env.VITE_SENTRY_DSN
  if (!dsn) return

  Sentry.init({
    app,
    dsn,
    environment: import.meta.env.VITE_SENTRY_ENVIRONMENT || undefined,
    release: import.meta.env.VITE_SENTRY_RELEASE || __GIT_COMMIT_FULL__,
    dist: __BUILD_TIME__,
    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.vueIntegration({ app, tracingOptions: { trackComponents: true } }),
    ],
    sendDefaultPii: false,
    initialScope: {
      tags: {
        git_commit: __GIT_COMMIT_FULL__,
        git_branch: __GIT_BRANCH__,
        build_time: __BUILD_TIME__,
        telegram_platform: getTelegramPlatform(),
        telegram_version: getTelegramVersion(),
        inside_telegram: String(isInsideTelegram()),
      },
    },
    tracesSampleRate: parseSampleRate(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE) ?? 0,
  })
}
